export const HOME_URL = "/";
export const OPERADORAS_URL = "/operadoras";
export const APLICATIVOS_URL = "/aplicativos";
export const PLANOS_URL = "/planos";
